import CarbonProvider from 'carbon-react/lib/components/carbon-provider';
import I18nProvider from 'carbon-react/lib/components/i18n-provider';
import GlobalStyle from 'carbon-react/lib/style/global-style';
import Aegean from 'carbon-react/lib/style/themes/sage';
import type { PropsWithChildren } from 'react';
import { LaunchDarklyProvider } from './analytics/LaunchDarklyProvider';
import ToastContainer from './components/ToastContainer';
import { HeadManager } from './helpers/head-manager';

type AppProviderProps = Record<string, unknown>;

export default function AppProviders({
  children,
}: PropsWithChildren<AppProviderProps>) {
  return (
    <I18nProvider>
      <LaunchDarklyProvider>
        <CarbonProvider theme={Aegean}>
          <GlobalStyle />
          <HeadManager />
          {children}
          <ToastContainer />
        </CarbonProvider>
      </LaunchDarklyProvider>
    </I18nProvider>
  );
}
